// extracted by mini-css-extract-plugin
export var checkboxInputRow = "J_vr";
export var checkboxInputColumn = "J_vs";
export var inputOptionRow = "J_qJ";
export var inputOptionColumn = "J_qK";